import React from 'react';
import { formatCurrency } from '../../utils/formatCurrency';

/**
 * CartTotals - Order totals breakdown display
 * 
 * Shows:
 * - Subtotal
 * - Promo discount (if applied)
 * - Tax
 * - Total
 * 
 * Note: Tip is shown on payment page, not cart
 */
export default function CartTotals({
  subtotal = 0,
  discount = 0,
  discountLabel = '',
  total = 0,
  itemCount = 0,
  className = '',
}) {
  const hasDiscount = discount > 0;

  return (
    <div className={`space-y-3 ${className}`}>
      {/* Item Count */}
      <div className="flex items-center justify-between text-sm text-gray-400">
        <span>{itemCount} {itemCount === 1 ? 'item' : 'items'}</span>
      </div>

      {/* Divider */}
      <div className="h-px bg-white/10" />

      {/* Subtotal */}
      <div className="flex items-center justify-between">
        <span className="text-base text-gray-300">Subtotal</span>
        <span className="text-base font-medium text-white">
          {formatCurrency(subtotal)}
        </span>
      </div>

      {/* Discount */}
      {hasDiscount && (
        <div className="flex items-center justify-between text-[#10b981]">
          <span className="text-base">
            Discount
            {discountLabel && (
              <span className="ml-2 text-sm opacity-80">({discountLabel})</span>
            )}
          </span>
          <span className="text-base font-medium">
            -{formatCurrency(discount)}
          </span>
        </div>
      )}

      {/* Tax: the server's, on the payment screen */}
      <div className="flex items-center justify-between">
        <span className="text-base text-gray-300">Tax</span>
        <span className="text-sm text-gray-400" data-testid="kiosk-tax-at-checkout">Calculated at checkout</span>
      </div>

      {/* Divider */}
      <div className="h-px bg-white/10" />

      <div className="flex items-center justify-between pt-1">
        <span className="text-xl font-semibold text-white">{hasDiscount ? 'After discount' : 'Subtotal'}</span>
        <span className="text-2xl font-bold text-[#f5a623]">
          {formatCurrency(total)}
        </span>
      </div>

      {/* Note about tip */}
      <p className="text-xs text-gray-500 text-center pt-2">
        Tax and tip are added on the payment screen
      </p>
    </div>
  );
}
